export default __webpack_public_path__ + "static/media/liyide.163ef5ef.jpeg";